import { tableCellClasses, type Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';
import { ArrowDownwardRounded } from '@mui/icons-material';

import { SPACING } from '@/mui/constants';

export default function MuiTableSortLabel(theme: Theme): Components['MuiTableSortLabel'] {
  const fontSize = 12;
  const gap = 1;

  const fullGap = SPACING * gap + fontSize;

  return {
    defaultProps: {
      IconComponent: ArrowDownwardRounded,
    },
    styleOverrides: {
      root: ({ ownerState }) => ({
        gap: theme.spacing(1),

        [`.${tableCellClasses.alignCenter} &`]: {
          marginInlineStart: ownerState.active || !ownerState.hideSortIcon ? fullGap : 0,
        },
      }),
      icon: {
        fontSize,
        margin: 0,
      },
    },
  };
}
